var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0B76FF",
    d: "M12 14.572h3.557l-3.557-6V4.714l7.286 12H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24C1FF",
    d: "M12 14.572H8.426l3.574-6V4.714l-7.286 12H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39FFF2",
    d: "M12 10.286v3.428H9.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E2C2",
    d: "M12 10.286v3.428h2.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBeam0)",
    d: "m3.429 8.469l8.563 3.96v.415l-8.563-1.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBeam1)",
    d: "m20.572 7.316l-8.58 5.117v.141l8.58-3.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBeam2)",
    d: "m20.572 12.274l-8.58.575v-.138l8.58-2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBeam3)",
    d: "m20.572 8.97l-8.58 3.6v.141l8.58-2.09z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBeam0",
    x1: 3.437,
    x2: 12.824,
    y1: 10.744,
    y2: 10.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBeam1",
    x1: 20.469,
    x2: 9.568,
    y1: 10.69,
    y2: 10.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD76FD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBeam2",
    x1: 20.649,
    x2: 11.82,
    y1: 10.737,
    y2: 10.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D6EFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A18CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBeam3",
    x1: 20.563,
    x2: 15.514,
    y1: 10.847,
    y2: 10.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE60D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB38E6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeam);
export default __webpack_public_path__ + "static/media/beam.ffd5fb21a4fe02f5cc20180b75c1027e.svg";
export { ForwardRef as ReactComponent };